import DropDown from './DropDown'

type Option = { 
  title: string
  value: string 
}

interface SelectProps {
  label?: string
  options: Option[]
  value?: string
  onChange?: (value: string) => void
  placeholder?: string
  className?: string
  disabled?: boolean
  size?: 'small' | 'large'
}

export const Select = ({ label, size = 'large', ...props }: SelectProps) => {
  return (
    <div>
      {label && (
        <label className="block text-[14px] font-[600] text-foreground mb-1">{label}</label>
      )}
      <DropDown size={size} {...props} />
    </div>
  )
}